import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withTranslations from '../../translations';

import {
  getLogs,
  clearLogs,
} from '../../actions/logs';

import {
  Grid,
  Loader,
  Pagination,
} from '../base';

import Log from './Log/Log';

const styles = theme => ({
  expansionPanel: {
    width: `calc(100% - ${theme.spacing(2)}px)`,
    margin: `${theme.spacing(4)}px auto`,

    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${theme.spacing(8)}px)`,
    },
  },
  title: {
    fontSize: 22,
  },
  logsContainer: {
    display: 'block',

    [theme.breakpoints.up('lg')]: {
      width: '50%',
    },
  },
  logsAndPaginationContainer: {
    width: '100%',
  }
})

class LogSection extends Component {
  limit = 7;

  state = {
    offset: 0,
  }

  componentDidMount() {
    this.props.actions.getLogs(this.props.jobId, this.limit)
  }

  componentWillUnmount() {
    this.props.actions.clearLogs();
  }

  handlePagination = offset => this.setState({offset})

  renderLogsWithPagination = () => {
    const { t, gt, logs, total, classes: c } = this.props;
    const { offset } = this.state;
    const page = offset / this.limit;

    return (
      logs.length
      ? <div className={c.logsAndPaginationContainer}>
          <div className={c.logsContainer}>
            {logs[page].map(log => <Log key={log.id} t={t} gt={gt} data={log} />)}
          </div>
          <Pagination
            limit={this.limit}
            offset={offset}
            total={total}
            onClick={(e, offset) => this.handlePagination(offset)}
          />
        </div>
      : <p>{gt.noInfo}</p>
    );
  }

  render() {
    return (
      <Grid container>
        { this.props.logs ? this.renderLogsWithPagination() : <Loader color='secondary' /> }
      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  logs: state.logs.logs,
  total: state.logs.total,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getLogs: bindActionCreators(getLogs, dispatch),
    clearLogs: bindActionCreators(clearLogs, dispatch),
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withTranslations(LogSection, 'LogSection')));



// WEBPACK FOOTER //
// ./src/components/LogSection/LogSection.js